import {http} from "Services/Http/HttpClient";
import FilterBuilder from "Services/Filters/FilterBuilder";

export const getPreorderInscriptions = async() => {
    return await http.get('inscription-orders/preorder')
}
